import React, { createContext, useContext, useState, useEffect } from 'react';

const LandingContentContext = createContext({});

export function LandingContentProvider({ children }) {
  const [content, setContent] = useState(null);
  const API = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    fetch(`${API}/api/shop/landing-content`)
      .then(r => r.json())
      .then(d => setContent(d))
      .catch(() => {});
  }, [API]);

  return (
    <LandingContentContext.Provider value={content || {}}>
      {children}
    </LandingContentContext.Provider>
  );
}

export function useLandingContent() {
  return useContext(LandingContentContext);
}
